import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { coreSocket } from '../services/core/coreSocket';
import { dispatchNotificationAction } from '../services/notifications/notificationActions';
import { showNotificationToast } from '../utils/toast';
import { notificationsQueryKey } from './useNotifications';

export const useNotificationSocket = (userId?: string | null) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!userId) {
      return;
    }

    const unsubscribe = coreSocket.subscribe('notification', (notification) => {
      if (notification?.message) {
        showNotificationToast(notification.message);
      }
      dispatchNotificationAction(notification?.action);
      void queryClient.invalidateQueries({ queryKey: notificationsQueryKey(userId) });
    });

    coreSocket.connect();

    return () => {
      unsubscribe();
      coreSocket.disconnect();
    };
  }, [userId, queryClient]);
};
